export { default as StoneChain } from './StoneChain.js';
export { default as MarkChain } from './MarkChain.js';
export { default as InfluenceChain } from './InfluenceChain.js';
export { default as InputValidator } from './InputValidator.js';

export default class {
  constructor(grid, stoneChain, markChain, infChain, input) {
    this.grid = grid;
    this.stoneChain = stoneChain;
    this.markChain = markChain;
    this.infChain = infChain;
    this.input = input;
    // KataGo's suggested next moves, drawn as numbered discs (replay only): [{ x, y, rank }].
    this.suggestions = null;
    // The stone actually played next, marked among the suggestions: { x, y, stone } or null.
    this.actual = null;
    // Squares of a territory map (replay only): [{ x, y, colour: 'black' | 'white' | 'blue' | 'red' }].
    this.squares = null;
  }
}
